import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { TutorialsActionType, TutorialsStore } from './TutorialsReducer.types';

// @ts-ignore
const initialState: TutorialsStore = Immutable.fromJS({
  isFetching: false,
  tutorials: null,
  tutorialsItem: null,
  isFetchingItem: false,
});

const TutorialsReducer = handleActions<any>(
  {
    REQUEST_TUTORIALS: (state: TutorialsStore) => state.set('isFetching', true),

    RESPONSE_TUTORIALS_FAILURE: (state: TutorialsStore) => state.set('isFetching', false),

    RESPONSE_TUTORIALS_SUCCESS: (state: TutorialsStore, action: TutorialsActionType) => {
      const readings = Immutable.fromJS(action.payload);

      return state.set('isFetching', false).set('tutorials', readings);
    },
    REQUEST_TUTORIALS_ITEM: (state: TutorialsStore) => state.set('isFetchingItem', true),
    RESPONSE_TUTORIALS_ITEM_FAILURE: (state: TutorialsStore) => state.set('isFetchingItem', false),
    RESPONSE_TUTORIALS_ITEM_SUCCESS: (state: TutorialsStore, action: TutorialsActionType) =>
      state.set('isFetchingItem', false).set('tutorialsItem', Immutable.fromJS(action.payload)),
    CLEAN_TUTORIALS_ITEM: (state: TutorialsStore) => state.set('isFetchingItem', false).set('tutorialsItem', null),
  },
  initialState
);

export default TutorialsReducer;
